import React, { useEffect, useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  SelectField,
  FunctionField,
  useRefresh,
  CreateButton,
} from 'react-admin';
import { ActionButton, Pagination } from '../../Components';
import { eventStatus } from '../../utils/choices';
import EventFilters from './filters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/pro-solid-svg-icons';
import { Visibility } from '@material-ui/icons';
import { actionButtonStyles } from 'styles';
import { format, addMinutes } from 'date-fns';
const EventList = (props) => {
  const refresh = useRefresh();
  const classes = actionButtonStyles();
  const handleSyncButton = () => {
    refresh();
  };
  return (
    <>
      <List
        bulkActionButtons={false}
        exporter={false}
        {...props}
        filters={<EventFilters />}
        actions={
          <CreateButton style={{ marginTop: '10px', marginRight: '10px', paddingTop: '10px' }}>  </CreateButton>
        }
        perPage={50}
        pagination={<Pagination />}
        empty={false}
      >
        <Datagrid>
          <TextField source="name" sortable={false} />
          <TextField source="plot.name" label="Plot name" sortable={false} />
          <FunctionField
            source="eventDate"
            label="Date and Time"
            sortable={false}
            render={(record) => {
              if (record.eventDateISO) {
                const date = new Date(record.eventDateISO);
                record.eventDate = {
                  // trigger build
                  date: format(addMinutes(date, date.getTimezoneOffset()), 'yyyy-MM-dd'),
                  time: format(addMinutes(date, date.getTimezoneOffset()), 'HH:mm'),
                };
              }
              return record.eventDate
                ? `${record.eventDate?.date} ${record.eventDate?.time}`
                : ''
            }
            }
          />
          <NumberField
            source="attendingActors"
            label="Actors"
            sortable={false}
          />
          <TextField
            source="eventLocation.name"
            label="Location"
            sortable={false}
          />
          <FunctionField
            source="eventDirector"
            label="Event Director"
            sortable={false}
            render={(record) =>
              record.eventDirector
                ? `${record.eventDirector?.firstName} ${record.eventDirector?.lastName}`
                : ''
            }
          />
          <SelectField source="status" choices={eventStatus} sortable={false} />

          <FunctionField
            render={(record) =>
              record.status === 'COMPLETED' ? (
                <EditButton
                  icon={<Visibility />}
                  label="ra.action.show"
                  className={classes.floatRight}
                  record={record}
                  basePath={props.basePath}
                />
              ) : (
                <EditButton
                  className={classes.floatRight}
                  record={record}
                  basePath={props.basePath}
                />
              )
            }
          />
          {/* <EditButton /> */}
        </Datagrid>
      </List>
      <ActionButton
        label="Sync"
        onClick={handleSyncButton}
        style={{ width: '10%', marginTop: '1rem' }}
        icon={<FontAwesomeIcon icon={faSync} />}
      />
    </>
  );
};

export default EventList;
